import { render } from "./TemplateGridView.vue?vue&type=template&id=5ab3b132&scoped=true"
import script from "./TemplateGridView.vue?vue&type=script&lang=ts"
export * from "./TemplateGridView.vue?vue&type=script&lang=ts"

import "./TemplateGridView.vue?vue&type=style&index=0&id=5ab3b132&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5ab3b132"

export default script